import React, { useEffect, useState } from 'react';
import { useAnimation } from 'framer-motion';

import { Container, Progress } from './ProgressBar.styles';
import { Color, Mode, Size } from './types';

export interface ProgressBarProps {
  /**
   * Maximum value
   */
  max: number;
  /**
   * Current value
   */
  value: number;
  /**
   * Component mode
   */
  mode?: Mode;
  /**
   * Component size
   */
  size?: Size;
}

/**
- The ProgressBar component displays an indicator showing the completion progress.
**/
const ProgressBar = ({
  max,
  value,
  mode = 'dark',
  size = 'regular',
}: ProgressBarProps) => {
  const isOverLimit = value > max;
  const percentage = isOverLimit ? 100 : Math.floor((value / max) * 100);
  const controls = useAnimation();

  const [color, setColor] = useState<Color>('success');

  useEffect(() => {
    controls
      .start({
        x: 0,
        transition: {
          type: 'easeInOut',
          duration: 1,
          backgroundColor: {
            type: 'easeIn',
            duration: 5,
          },
        },
      })
      .then(() => {
        isOverLimit && setColor('danger');
      });
  }, [controls, isOverLimit]);

  return (
    <Container role="progressbar" mode={mode} size={size}>
      <Progress
        color={color}
        width={percentage}
        animate={controls}
        initial={{ x: '-100%' }}
      />
    </Container>
  );
};

export default ProgressBar;
